import { render, staticRenderFns } from "./OneContentDialog.vue?vue&type=template&id=ba225d6e&"
import script from "./OneContentDialog.vue?vue&type=script&lang=js&"
export * from "./OneContentDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports